//#region src/link-target.ts
let LinkTarget = /* @__PURE__ */ function(LinkTarget) {
	LinkTarget["Self"] = "_self";
	LinkTarget["Blank"] = "_blank";
	LinkTarget["Modal"] = "modal";
	LinkTarget["Post"] = "post";
	return LinkTarget;
}({});
//#endregion
export { LinkTarget, LinkTarget as default };

//# sourceMappingURL=link-target.mjs.map